import { Position } from '@xyflow/react';

import { NodeType } from './node';

export const NodeConnectionTypes = {
  Main: 'main',
} as const;

export type NodeConnectionType = (typeof NodeConnectionTypes)[keyof typeof NodeConnectionTypes];

export type INodeInputFilter = {
  allowedNodeTypes: Array<{
    type: NodeType;
    maxConnections: number;
  }>;
};

export type INodeOutputFilter = {
  allowedNodeTypes: Array<{
    type: NodeType;
    maxConnections: number;
  }>;
};

export type INodeInputConfiguration = {
  type: NodeConnectionType;
  allowTriggers?: boolean; // if triggers allowed true , other connection won't be able to add .
  filter: INodeInputFilter | undefined;
  maxConnections?: number;
};

export type INodeOutputConfiguration = {
  type: NodeConnectionType;
  displayName?: string;
  category?: 'error' | 'success' | 'condition';
  maxConnections?: number;
  minConnections?: number;
  required?: boolean;
  handlerPosition?: Position;
  filter?: INodeOutputFilter;
};

export type ConnectionValidationResult = {
  isValid: boolean;
  error?: string;
  warning?: string;
  suggestion?: string;
};

// Node type categories for connection validation
export enum NodeTypeCategory {
  TRIGGER = 'trigger',
  AGENT = 'agent',
  LOGIC = 'logic',
  CONDITION = 'condition',
  UTILITY = 'utility',
  OUTPUT = 'output',
}

// Connection validation error types
export enum ConnectionValidationError {
  INCOMPATIBLE_TYPES = 'incompatible_types',
  MAX_CONNECTIONS_EXCEEDED = 'max_connections_exceeded',
  CIRCULAR_DEPENDENCY = 'circular_dependency',
  TRIGGER_AS_TARGET = 'trigger_as_target',
  INVALID_NODE_TYPE = 'invalid_node_type',
  REQUIRED_INPUT_MISSING = 'required_input_missing',
  FILTERED_CONNECTION = 'filtered_connection',
  DUPLICATE_CONNECTION = 'duplicate_connection',
}
